import formatPrice from './formatPrice';

export default (num: number) => formatPrice(num).replace(',00', ',-');
